import React from 'react';
import { Wrapper } from 'app/components/competitionModule/news/commonStyles';
export default function CompetitionModuleNewsBlock(_ref) {
  let {
    hide,
    children
  } = _ref;
  if (hide) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CompetitionModuleNewsBlock",
    "data-sentry-source-file": "CompetitionModuleNewsBlock.tsx"
  }, children);
}